import React, { useState, useEffect, useRef } from "react";

import { toast } from "react-toastify";

import Modal from "react-bootstrap/Modal";
import { InputGroup } from "react-bootstrap";
import { Button } from "react-bootstrap";

import axios from "@app/lib/axios";

import * as Constant from "@app/Constant.js";
import * as commonData from "@app/lib/common_data";
import utility from "@app/lib/utility";

import AgGridReactEx from "@app/components/AgGridReactEx";

const ManageServerConfig = ({}) => {
    const [loadingData, setLoadingData] = useState(true);
    const loginBranchInfo = utility.getLoginBranchInfo();
    const [data, setData] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [searchParam, setSearchParam] = useState({
        type: "",
        value: "",
    });
    const [showModal, setShowModal] = useState(false);
    const [selectedConfig, setSelectedConfig] = useState(false);
    useEffect(() => {
        if (!loginBranchInfo && !data) {
            getData();
        }
        return () => {};
    }, [data]);

    const getData = () => {
        axios({
            method: "get",
            url: `/api/system/server/config`,
        })
            .then((res) => {
                const result = res.data;
                setData(result.list);
                setLoadingData(false);
                applyData(searchParam, result.list);
            })
            .catch((error) => {
                console.log(error);
                setLoadingData(false);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const defaultColDef = {
        editable: false,
        sortable: true,
        filter: false,
        resizable: true,
        cellClass: "text-center",
        headerClass: "bg-dark text-light",
        suppressMovable: true,
    };
    const listColumn = [
        {
            headerName: "Key",
            field: "key",
            width: 100,
        },
        {
            headerName: "Value",
            field: "value",
        },
        {
            headerName: "Description",
            field: "description",
        },
        {
            headerName: "등록일",
            field: "createDate",
        },
        {
            headerName: "수정일",
            field: "updateDate",
        },
    ];
    const onRowClicked = (params) => {
        if (params && params.data) {
            setSelectedConfig(params.data);
            setShowModal(true);
        }
    };
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            onSearch();
        }
    };
    const onSearch = () => {
        applyData(searchParam, data);
    };

    const applyData = (searchParam, list) => {
        var tableData = listSearch(searchParam, list);
        console.debug(tableData);

        setTableData(tableData);
        setSearchParam(searchParam);
    };

    const searchField = ["key"];
    const listSearch = (searchParam, list) => {
        let tableDataNew = [];
        if (!list) {
            list = [];
        }
        if (!searchParam.type && !searchParam.value) {
            tableDataNew = list;
        } else {
            list.forEach((item) => {
                searchField.forEach((field) => {
                    if (searchParam.type && item.status !== searchParam.type) {
                        return;
                    }
                    if (!searchParam.value || (item[field] && item[field].indexOf(searchParam.value) >= 0)) {
                        if (tableDataNew.findIndex((d) => d.id == item.id) == -1) {
                            tableDataNew.push(item);
                        }
                    }
                });
            });
        }
        return tableDataNew;
    };

    let gridApi = null;
    const onGridReady = (params) => {
        gridApi = params.api;
    };

    return (
        <div className="dashboard-wrapper">
            <div className="dashboard-ecommerce">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                            <div className="page-header">
                                <h2 className="pageheader-title">서버 설정값 관리</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid dashboard-content">
                    <div className="row align-items-end">
                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 pl-4">
                            <h5 className="mb-0" style={{ alignSelf: "end" }}>
                                <span>
                                    {tableData && tableData.length > 0 ? tableData.length.toLocaleString() : "0"} / {data && data.length > 0 ? data.length.toLocaleString() : "0"}
                                </span>
                            </h5>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"></div>
                        <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 pb-2">
                            <InputGroup className="input-group my-group">
                                <InputGroup.Append>
                                    <Button
                                        className="btn btn-success mr-3"
                                        onClick={() => {
                                            setSelectedConfig(false);
                                            setShowModal(true);
                                        }}
                                    >
                                        등록
                                    </Button>
                                </InputGroup.Append>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={searchParam.value}
                                    placeholder="설정 검색"
                                    onChange={(e) => {
                                        const param = { ...searchParam };
                                        param.value = e.target.value;
                                        setSearchParam(param);
                                    }}
                                    onKeyPress={handleKeyPress}
                                />
                                <InputGroup.Append>
                                    <Button className="btn btn-primary" onClick={onSearch}>
                                        검색
                                    </Button>
                                </InputGroup.Append>
                            </InputGroup>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <AgGridReactEx
                                defaultColDef={defaultColDef}
                                columnDefs={listColumn}
                                rowData={tableData}
                                onRowClicked={onRowClicked}
                                height={550}
                                pagination={false}
                                onGridReady={onGridReady}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <ServerConfigModal
                show={showModal}
                isNew={selectedConfig == false}
                onHide={(dataRefresh) => {
                    console.debug(dataRefresh);
                    if (dataRefresh) {
                        setSelectedConfig(false);
                        setData(false);
                    }
                    setShowModal(false);
                }}
                selectedConfig={selectedConfig}
            />
        </div>
    );
};

const ServerConfigModal = ({ show, onHide, isNew, selectedConfig = false }) => {
    const [serverConfig, setServerConfig] = useState(
        selectedConfig
            ? selectedConfig
            : {
                  key: "",
                  value: "",
                  description: "",
                  createDate: "",
                  updateDate: "",
              }
    );
    useEffect(() => {
        setServerConfig(
            selectedConfig
                ? selectedConfig
                : {
                      key: "",
                      value: "",
                      description: "",
                      createDate: "",
                      updateDate: "",
                  }
        );
        return () => {};
    }, [show]);

    const changeStrHandler = (e) => {
        const { name, value } = e.target;
        const newServerConfig = { ...serverConfig };

        newServerConfig[name] = value;
        setServerConfig(newServerConfig);
    };

    const upsertData = () => {
        const { key, value, description } = serverConfig;

        if (!key.trim()) {
            alert("Key를 입력해 주세요.");
            return;
        }

        if (!value.trim()) {
            alert("값을 입력해 주세요.");
            return;
        }

        if (!description.trim()) {
            alert("설명을 입력해 주세요.");
            return;
        }

        axios({
            method: "post",
            url: `/api/system/server/config`,
            data: {
                key,
                value,
                description,
            },
        })
            .then((res) => {
                alert(`서버 설정값이 ${isNew ? "추가" : "수정"}되었습니다.`);
                onHide(true);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const deleteData = () => {
        if (window.confirm(`해당 키를 정말 삭제하시겠습니까?\n${serverConfig.key}`)) {
            axios({
                method: "delete",
                url: `/api/system/server/config`,
                data: {
                    key: serverConfig.key,
                },
            })
                .then((res) => {
                    alert("서버 설정값이 삭제 되었습니다.");
                    onHide(true);
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        }
    };

    return (
        <Modal
            show={show}
            size="lg"
            onHide={() => {
                onHide(false);
            }}
            aria-labelledby="example-custom-modal-styling-title"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">설정값 {isNew ? "등록" : "수정"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="form-row">
                    <div className="col">
                        <label htmlFor="key">Key</label>
                        <input type="text" className="form-control" id="key" name="key" tabIndex="1" value={serverConfig.key} onChange={changeStrHandler} />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col">
                        <label htmlFor="value">Value</label>
                        <textarea className="form-control" id="value" name="value" rows="3" tabIndex="3" onChange={changeStrHandler} value={serverConfig.value} />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col">
                        <label htmlFor="description">설명</label>
                        <textarea className="form-control" id="description" name="description" rows="5" tabIndex="3" onChange={changeStrHandler} value={serverConfig.description} />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col">
                        <label htmlFor="createDate">등록일</label>
                        <input type="text" className="form-control" disabled id="createDate" name="createDate" value={serverConfig.createDate} />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col">
                        <label htmlFor="updateDate">수정일</label>
                        <input type="text" className="form-control" disabled id="updateDate" name="updateDate" value={serverConfig.updateDate} />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {!isNew && (
                    <button className="btn btn-danger" onClick={deleteData}>
                        삭제
                    </button>
                )}
                <button className="btn btn-primary" onClick={upsertData}>
                    저장
                </button>
                <button className="btn btn-outline-dark" onClick={() => onHide(false)}>
                    취소
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export { ManageServerConfig as default };
